import React from "react";
export default function ProStarFilledIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      style={{backgroundColor: "#E7B853", borderRadius: '100px', padding: '4px'}}
      viewBox="0 0 16 16"
    >
      <g>
        <path
          fill="#fff"
          d="M8.072 1.536l2.1 4.16a.082.082 0 00.06.042l4.702.665a.08.08 0 01.062.053.076.076 0 01-.02.079l-3.4 3.236a.079.079 0 00-.023.07l.802 4.57a.075.075 0 01-.031.075.079.079 0 01-.083.005l-4.204-2.157a.084.084 0 00-.074 0L3.76 14.49a.08.08 0 01-.11-.039.075.075 0 01-.004-.042l.803-4.57a.077.077 0 00-.023-.069l-3.4-3.236a.076.076 0 01-.021-.08.076.076 0 01.024-.035.079.079 0 01.04-.017l4.701-.665a.082.082 0 00.06-.043l2.108-4.159a.079.079 0 01.067-.036.081.081 0 01.068.036z"
        ></path>
      </g>
    </svg>
  );
}
